import { render, staticRenderFns } from "./BasePreviewOutput.vue?vue&type=template&id=36ac9d42&"
import script from "./BasePreviewOutput.vue?vue&type=script&lang=js&"
export * from "./BasePreviewOutput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports